import * as React from "react";
import coreSliceRenderers from "components/events/SliceRenderers";
import { SECURITY_EVENT_STATUSES } from "security-app/hooks/api/securityEventsAPI.types";
import { AssigneeCell } from "security-app/components/common";
const extendStatusSlices = (slices) => {
  const countsByValue = new Map(slices.map((slice) => [String(slice.value), slice.count]));
  return Object.entries(SECURITY_EVENT_STATUSES).map(([value, title]) => {
    var _a;
    return {
      value,
      title,
      count: (_a = countsByValue.get(value)) != null ? _a : 0
    };
  });
};
const emptyValue = /* @__PURE__ */ React.createElement("i", null, "none");
const sliceRenderers = {
  ...coreSliceRenderers,
  owner: {
    render: ({ value, title, type }) => {
      if (value === null) {
        return emptyValue;
      }
      return /* @__PURE__ */ React.createElement(AssigneeCell, { assignee: { label: title, type: type === "teams" ? "team" : "user", id: String(value) } });
    }
  },
  status: {
    extendSlices: extendStatusSlices,
    render: ({ value }) => {
      var _a;
      return /* @__PURE__ */ React.createElement("span", null, (_a = SECURITY_EVENT_STATUSES[String(value)]) != null ? _a : String(value));
    }
  },
  associated_assets: {
    render: ({ value, title }) => {
      if (value === null) {
        return emptyValue;
      }
      return title;
    }
  },
  associated_investigations: {
    render: ({ value, title }) => {
      if (value === null) {
        return emptyValue;
      }
      return title;
    }
  }
};
export default sliceRenderers;
